import { parser } from 'posthtml-parser';
import { render } from 'posthtml-render';
import { MjmlAttribute } from './attributes';
import { MJ } from './elements';
const CUSTOM_HTML_MARKER = new RegExp(`${MjmlAttribute.CUSTOM_HTML}\\s*=\\s*["']?true`);
export const hasCustomHtmlMarker = mjml => CUSTOM_HTML_MARKER.test(mjml);
const isNodeTag = node => typeof node === 'object' && node !== null && 'tag' in node;
export const isCustomHtmlNode = node => {
  var _node$attrs;
  return isNodeTag(node) && node.tag === MJ.TEXT && ((_node$attrs = node.attrs) == null ? void 0 : _node$attrs[MjmlAttribute.CUSTOM_HTML]) === 'true';
};
const sanitizeNodes = (nodes, sanitize) => nodes.map(node => {
  if (!isNodeTag(node)) {
    return node;
  }
  if (isCustomHtmlNode(node)) {
    const content = Array.isArray(node.content) ? node.content : [];
    return {
      ...node,
      content: [sanitize(render(content))]
    };
  }
  return Array.isArray(node.content) ? {
    ...node,
    content: sanitizeNodes(node.content, sanitize)
  } : node;
});
export const sanitizeCustomHtmlBlocksInMjml = (mjml, sanitize) => {
  if (!hasCustomHtmlMarker(mjml)) {
    return mjml;
  }
  return render(sanitizeNodes(parser(mjml, {
    recognizeSelfClosing: true
  }), sanitize));
};
//# sourceMappingURL=customHtml.js.map